// import { getInstance } from "./index";
// import profileApi from "../api/profile";

export const authGuard = (to, from, next) => {
  return next();
  // const authService = getInstance();

  // const fn = () => {
  //   if (!authService.isAuthenticated) {
  //     authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  //   }

  //   if (to.meta.requiresCompanyAdmin && !authService.isCompanyAdmin()) {
  //     return next("/");
  //   }

  //   if (to.meta.checkSetup) {
  //     profileApi.getProfileSetup(setup => {
  //       if (!setup) {
  //         return next("/setup");
  //       } else {
  //         return next();
  //       }
  //     });
  //   } else {
  //     return next();
  //   }
  // };

  // // If loading has already finished, check the auth state using `fn()`
  // if (!authService.loading) {
  //   return fn();
  // }

  // // Watch for the loading property to change before checking isAuthenticated
  // authService.$watch("loading", loading => {
  //   if (loading === false) {
  //     return fn();
  //   }
  // });
};
